import { paramCreator } from "../../../../utils/api";
import { toastExcelError, toastWarn } from "../../../../utils/pageUtil/toast";

export const exportOnlySelectedFlyerItems = async (
  flyerItemListId: string,
  flyerItemIds: string[],
  Authorization: string
) => {
  try {
    const { url, options } =
      paramCreator.gfFlyerItemAdminControllerExportExcelByIds(
        flyerItemIds,
        flyerItemListId,
        {
          headers: {
            Authorization: Authorization,
          },
        }
      );
    const response = await fetch(
      process.env.REACT_APP_GOFLYER_API_END_POINT + url,
      { ...options }
    );
    if (!response.ok) {
      const errorData = await response.json();
      toastWarn(`${errorData.message} For that Selected Category`);
      return;
    }
    const blob = await response.blob();

    const name = response.headers.get("X-File-Name");
    const fileName = decodeURIComponent(name ?? "flyer-items.xlsx");

    const blobUrl = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    toastExcelError("Failed to export Excel file");
    console.error("Download failed:", error);
  }
};
